import { IconCircleCheck } from '@tabler/icons-react'

import Button from 'components/ui/button'
import Text from 'components/ui/text'
import { translate } from 'utils/translation'
import { sendMessage } from 'utils/functions'

import { useLeadCaptureStore } from '../store/lead-capture-store'

export const Success = () => {
  const { setIsModalOpen, setView } = useLeadCaptureStore()

  const handleClose = () => {
    setIsModalOpen(false)
    sendMessage('LEAD_CAPTURE_SUCCESS_CLOSED')
    setTimeout(() => {
      setView('initial')
    }, 1000)
  }

  return (
    <div className="tw-flex tw-w-full tw-items-center tw-justify-center tw-bg-white tw-p-6">
      <div className="tw-flex tw-flex-col tw-items-center tw-gap-4">
        <IconCircleCheck
          strokeWidth={2}
          size={48}
          className="tw-text-emerald-500"
        />

        <div className="tw-flex tw-flex-col tw-items-center tw-gap-3 tw-text-center">
          <Text
            as="h1"
            className="tw-m-0 tw-text-3xl tw-font-bold tw-text-zinc-900"
          >
            help_form_success_heading
          </Text>
          <Text
            as="p"
            className="tw-m-0 tw-text-lg tw-font-normal tw-text-zinc-700"
          >
            help_form_success_subheading
          </Text>
        </div>

        <div className="tw-mt-2 tw-flex tw-justify-center">
          <Button onClick={handleClose} variant="neutral-solid" size="lg">
            {translate('close')}
          </Button>
        </div>
      </div>
    </div>
  )
}
